export default {
    getModelOfic: (state) => {
        return state.oficina
    }
}